import {z} from 'zod';

export const workshopCustomerGroupFormPageFormSchema = z.object({
  name: z.string(),
  code: z.string().nullish(),
});

export type WorkshopCustomerGroupFormPageFormType = z.infer<
  typeof workshopCustomerGroupFormPageFormSchema
>;
